import { render, staticRenderFns } from "./ApplicationRecordDetails.vue?vue&type=template&id=8d3f3874&scoped=true"
import script from "./ApplicationRecordDetails.vue?vue&type=script&lang=js"
export * from "./ApplicationRecordDetails.vue?vue&type=script&lang=js"
import style0 from "./ApplicationRecordDetails.vue?vue&type=style&index=0&id=8d3f3874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3f3874",
  null
  
)

export default component.exports